import type { BundledTranslationChanges } from "../Translations/RenameEntityModal";
import type { SportsbookListTranslations } from "../Translations/listTranslationData";

export const ENTITY_TYPES = {
  PREMATCH: "PREMATCH",
  LIVE: "LIVE",
} as const;

export type EntityType = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];

export interface Token {
  AccessToken?: string;
}

export interface Sport {
  id: number | string;
  name: string;
}

export interface RawSport {
  sport_id: number | string;
  name: string;
}

export interface Tab {
  entity_id: string;
  tab_id: string;
  name: string;
  order: number;
  card_count: number;
  is_active?: boolean;
  translations?: SportsbookListTranslations | null;
}

export interface RawTab {
  entity_id: string;
  name?: string;
  display_name?: string | null;
  display_order?: number | string | null;
  card_count?: number | null;
  is_active?: boolean;
  translations?: SportsbookListTranslations | null;
}

export interface Card {
  entity_id: string;
  market_id: string | number;
  name: string;
  display_name: string;
  order: number;
  is_active?: boolean;
  tab_id: string;
  tab_name: string;
  tab_order: number;
  translations?: SportsbookListTranslations | null;
}

export interface RawCard {
  entity_id: string;
  market_id: string | number;
  name: string;
  display_name?: string | null;
  display_order?: number | string | null;
  is_active?: boolean;
  translations?: SportsbookListTranslations | null;
}

export interface MarketOption {
  entity_id: string;
  market_id: string | number;
  item_name: string;
  item_type: "MARKET";
  sport_name?: string;
}

export interface RawMarketOption {
  entity_id?: string | null;
  market_id: string | number;
  display_name?: string | null;
  name?: string | null;
}

export interface RenameMarketPayload {
  sport_id: Sport["id"];
  market_id: Card["market_id"];
  current_display_name?: string | null;
  translations?: SportsbookListTranslations | null;
  entity_id?: string;
}

export interface DeleteCardTarget {
  tabId: string;
  marketId: Card["market_id"];
}

export interface ReorderCardsVariables {
  tabId: string;
  orderedMarketIds: string[];
}

export interface CreateCardVariables {
  tabId: string;
  marketId: Card["market_id"];
}

export type { BundledTranslationChanges };

export interface RenameMarketVariables {
  marketId: Card["market_id"];
  newDisplayName: string;
  translationChanges?: BundledTranslationChanges;
}

export type MarketCardRowHandler = (card: Card) => void;
